import React, { useEffect, useRef, useState } from "react";
import photo from "../../../assets/images/user4.jpg";
import { IMemberListData } from "../../../exports/interfaces";
import PersonalInformation from "./PersonalInformation";
import ContactInformation from "./ContactInformation";
import OperationInfromation from "./OperationInfromation";
import Uploads from "./Uploads";
import useMobile from "../../../hooks/useMobile";
import useTab from "../../../hooks/useTab";
import { useLoader } from "../../../context/LoaderContext";
import axios from "axios";
import { headers } from "../../../exports/exports";
import { failed, success } from "../../../hooks/useToast";
import {
  downloadPDF,
  generatePDF,
  getMembershipStatusColor,
} from "../../../exports/functions";
import DynamicToolTip from "../../DynamicToolTip";

const ProfileInformation = (props: {
  listMemberData: IMemberListData[];
  getUserById: () => void;
}) => {
  const mobile = useMobile();
  const tab = useTab();
  const { setLoading } = useLoader();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const profilePicData =
    props.listMemberData[0]?.attributes?.Profile_Picture?.data;
  const [memberId, setMemberId] = useState<number>(0);
  const [activeTab, setActiveTab] = useState<string>("personal");
  const [firstname, setFirstname] = useState<string>("");
  const [middlename, setMiddlename] = useState<string>("");
  const [lastname, setLastname] = useState<string>("");
  const [age, setAge] = useState<number | null>(null);
  const [sex, setSex] = useState<string>("");
  const [designation, setDesignation] = useState<string>("");
  const [qualifications, setQualifications] = useState<string>("");
  const [professionalAffiliations, setProfessionalAffiliations] =
    useState<string>("");
  const [mobilenumber, setMobileNumber] = useState<string>("");
  const [whatsappnumber, setWhatsappNumber] = useState<string>("");
  const [permanentAddress, setPermanentAddress] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [stateProvince, setStateProvince] = useState<string>("");
  const [postalZipCode, setPostalZipCode] = useState<number | null>(null);
  const [country, setCountry] = useState<string>("");
  const [workAddress, setWorkAddress] = useState<string>("");
  const [workCity, setWorkCity] = useState<string>("");
  const [workStateProvince, setWorkStateProvince] = useState<string>("");
  const [workPostalZipCode, setWorkPostalZipCode] = useState<number | null>(
    null,
  );
  const [workCountry, setWorkCountry] = useState<string>("");

  useEffect(() => {
    setFirstname(props?.listMemberData[0]?.attributes?.First_Name);
    setMiddlename(props?.listMemberData[0]?.attributes?.Middle_Name);
    setLastname(props?.listMemberData[0]?.attributes?.Last_Name);
    setAge(props?.listMemberData[0]?.attributes?.Age);
    setSex(props?.listMemberData[0]?.attributes?.Sex);
    setDesignation(props?.listMemberData[0]?.attributes?.Designation);
    setQualifications(props?.listMemberData[0]?.attributes?.Qualifications);
    setProfessionalAffiliations(
      props?.listMemberData[0]?.attributes?.Professional_Affiliations,
    );
    setMobileNumber(props?.listMemberData[0]?.attributes?.Mobile_Number);
    setWhatsappNumber(props?.listMemberData[0]?.attributes?.WhatsAPP_Number);
    setPermanentAddress(
      props?.listMemberData[0]?.attributes?.Permanent_Address,
    );
    setCity(props?.listMemberData[0]?.attributes?.City);
    setStateProvince(props?.listMemberData[0]?.attributes?.State_Province);
    setPostalZipCode(props?.listMemberData[0]?.attributes?.Postal_Zip_Code);
    setCountry(props?.listMemberData[0]?.attributes?.Country);
    setWorkAddress(props?.listMemberData[0]?.attributes?.Work_Address);
    setWorkCity(props?.listMemberData[0]?.attributes?.Work_City);
    setWorkStateProvince(
      props?.listMemberData[0]?.attributes?.Work_State_Province,
    );
    setWorkPostalZipCode(
      props?.listMemberData[0]?.attributes?.Work_Postal_Zip_Code,
    );
    setWorkCountry(props?.listMemberData[0]?.attributes?.Work_Country);
    setMemberId(props?.listMemberData[0]?.id);
  }, [props?.listMemberData]);

  const handleEditClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("files", file);

      const uploadRes = await axios.post(
        `${process.env.REACT_APP_strapiUrl}/api/upload`,
        formData,
        {
          headers: {
            Authorization: headers.Authorization,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const uploadedImageId = uploadRes.data[0].id;
      const data = {
        data: {
          Profile_Picture: uploadedImageId,
        },
      };

      const userRes = await axios.put(
        `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${memberId}`,
        data,
        {
          headers,
        },
      );
      if (userRes?.status === 200 || userRes?.status === 201) {
        props.getUserById();
        success();
      }
    } catch (error) {
      failed();
    }
  };
  const { color } = getMembershipStatusColor(
    props.listMemberData[0]?.attributes?.Status,
  );
  const statusNotices =
    props.listMemberData.length > 0 &&
    Array.isArray(props.listMemberData[0]?.attributes?.frcsit_notices?.data)
      ? props.listMemberData[0].attributes.frcsit_notices.data
          .filter((notice: any) => notice.attributes.Type === "status")
          .sort(
            (a: any, b: any) =>
              new Date(b.attributes.createdAt).getTime() -
              new Date(a.attributes.createdAt).getTime(),
          )
      : [];

  return (
    <section
      className="quality-work"
      style={{
        padding: "0px 0px 20px 0px",
        // marginTop: (!mobile && !tab) ? "88px" : "unset",
        marginLeft: !mobile && !tab ? "240px" : "unset",
      }}
    >
      <div className="container">
        <div
          className="section-title custom-text-center"
          style={{ marginBottom: "10px" }}
        >
          <h2 className="section-title__title custom-user-section-title">
            Profile
          </h2>
        </div>
        <div className="row">
          <div className="col-xl-4">
            <div className="quality-work__tab-box tabs-box">
              <div
                className="donation-details__presentation custom-feature-two__single"
                style={{
                  padding: "0px",
                  backgroundColor: "transparent",
                  height: "auto",
                }}
              >
                <div className="user-card">
                  <div className="user-card__header">
                    <div className="user-card__image">
                      {profilePicData !== null &&
                      profilePicData !== undefined ? (
                        <img
                          src={
                            profilePicData.attributes.url &&
                            `${process.env.REACT_APP_strapiUrl}${profilePicData.attributes.url}`
                          }
                          alt="User"
                        />
                      ) : (
                        <img src={photo} alt="User" />
                      )}
                      <div
                        className="edit-profil-pic-icon"
                        onClick={handleEditClick}
                      >
                        <span className="icon-pencil"></span>
                      </div>
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                    <div className="user-card__info">
                      <h3>
                        {props?.listMemberData[0]?.attributes?.First_Name}
                      </h3>
                      <p className="user-card__designation">
                        {props?.listMemberData[0]?.attributes?.Designation}
                      </p>
                    </div>
                    <div className={`user-card__status ${mobile && "mt-2"}`}>
                      <div>
                        Status:{" "}
                        <div
                          className="statu-chip"
                          style={{
                            color: color,
                          }}
                        >
                          {props.listMemberData[0]?.attributes?.Status}
                        </div>
                      </div>
                      {props.listMemberData[0]?.attributes?.Status ===
                        "Active" && (
                        <div className="d-flex align-items-center gap-2">
                          Certificate:{" "}
                          <div className="d-inline-flex align-items-end gap-1">
                            <DynamicToolTip title="View Certificate">
                              <span
                                className="icon-file-text custom-certificate"
                                onClick={() => {
                                  const fullName = [
                                    // props.listMemberData[0]?.attributes
                                    //   ?.Designation,
                                    props.listMemberData[0]?.attributes
                                      ?.First_Name,
                                    props.listMemberData[0]?.attributes
                                      ?.Middle_Name ?? "",
                                    props.listMemberData[0]?.attributes
                                      ?.Last_Name,
                                  ]
                                    .filter(Boolean)
                                    .join(" ");
                                  generatePDF(fullName);
                                }}
                              ></span>
                            </DynamicToolTip>
                            <DynamicToolTip title="Download Certificate">
                              <span
                                className="fa fa-cloud-download-alt custom-download"
                                onClick={() => {
                                  const fullName = [
                                    // props.listMemberData[0]?.attributes
                                    //   ?.Designation,
                                    props.listMemberData[0]?.attributes
                                      ?.First_Name,
                                    props.listMemberData[0]?.attributes
                                      ?.Middle_Name ?? "",
                                    props.listMemberData[0]?.attributes
                                      ?.Last_Name,
                                  ]
                                    .filter(Boolean)
                                    .join(" ");
                                  downloadPDF(fullName);
                                }}
                              ></span>
                            </DynamicToolTip>
                          </div>
                        </div>
                      )}
                    </div>
                    {statusNotices.length > 0 &&
                      props.listMemberData[0]?.attributes?.Status !==
                        "Active" && (
                        <div
                          className="user-status__notice upload-subtext mt-2"
                          // style={{ textAlign: "end" }}
                        >
                          {statusNotices[0]?.attributes?.Message}
                        </div>
                      )}
                  </div>
                  <hr />
                  <div className="user-card__details">
                    <p>
                      <strong>Email:</strong>{" "}
                      <span>{props?.listMemberData[0]?.attributes?.Email}</span>
                    </p>
                    <p>
                      <strong>Phone:</strong>{" "}
                      <span>
                        {props?.listMemberData[0]?.attributes?.Mobile_Number}
                      </span>
                    </p>
                    <p>
                      <strong>Address:</strong>{" "}
                      <span>{props?.listMemberData[0]?.attributes?.City}</span>
                    </p>
                    <p>
                      <strong>Qualifications:</strong>{" "}
                      <span>
                        {props?.listMemberData[0]?.attributes?.Qualifications}
                      </span>
                    </p>
                    <p>
                      <strong>Professional Affiliations:</strong>{" "}
                      <span>
                        {
                          props?.listMemberData[0]?.attributes
                            ?.Professional_Affiliations
                        }
                      </span>
                    </p>
                    <p>
                      <strong>Membership Type:</strong>{" "}
                      <span>
                        {
                          props?.listMemberData[0]?.attributes
                            ?.Type_Of_Membership
                        }
                      </span>
                    </p>
                    <p>
                      <strong>Membership Expiry:</strong>{" "}
                      <span>
                        {props?.listMemberData[0]?.attributes
                          ?.Membership_Valid === 0
                          ? "Life Time"
                          : (props?.listMemberData[0]?.attributes
                              ?.Membership_Expiry ?? "-")}
                      </span>
                    </p>
                  </div>
                  <div className="user-tabs">
                    <ul className="user-tabs__menu">
                      <li
                        className={activeTab === "personal" ? "active" : ""}
                        onClick={() => setActiveTab("personal")}
                      >
                        <i className="fas fa-user"></i> Personal Information
                      </li>
                      <li
                        className={activeTab === "contact" ? "active" : ""}
                        onClick={() => setActiveTab("contact")}
                      >
                        <i className="fas fa-phone-alt"></i> Contact Information
                      </li>
                      <li
                        className={activeTab === "operations" ? "active" : ""}
                        onClick={() => setActiveTab("operations")}
                      >
                        <i className="fas fa-heartbeat"></i> Operations
                      </li>
                      <li
                        className={activeTab === "uploads" ? "active" : ""}
                        onClick={() => setActiveTab("uploads")}
                      >
                        <i className="fas fa-file-alt"></i> Uploads
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-8"
            style={{ marginTop: mobile || tab ? "10px" : "unset" }}
          >
            <div className="quality-work__tab-box tabs-box">
              <div
                className="donation-details__presentation custom-feature-two"
                style={{ padding: "16px", backgroundColor: "transparent" }}
              >
                <div className="row">
                  {activeTab === "personal" && (
                    <PersonalInformation
                      firstname={firstname}
                      setFirstname={setFirstname}
                      middlename={middlename}
                      setMiddlename={setMiddlename}
                      lastname={lastname}
                      setLastname={setLastname}
                      age={age}
                      setAge={setAge}
                      sex={sex}
                      setSex={setSex}
                      designation={designation}
                      setDesignation={setDesignation}
                      qualifications={qualifications}
                      setQualifications={setQualifications}
                      professionalAffiliations={professionalAffiliations}
                      setProfessionalAffiliations={setProfessionalAffiliations}
                      memberId={memberId}
                    />
                  )}
                  {activeTab === "contact" && (
                    <ContactInformation
                      mobilenumber={mobilenumber}
                      setMobileNumber={setMobileNumber}
                      whatsappnumber={whatsappnumber}
                      setWhatsappNumber={setWhatsappNumber}
                      permanentAddress={permanentAddress}
                      setPermanentAddress={setPermanentAddress}
                      city={city}
                      setCity={setCity}
                      stateProvince={stateProvince}
                      setStateProvince={setStateProvince}
                      postalZipCode={postalZipCode}
                      setPostalZipCode={setPostalZipCode}
                      country={country}
                      setCountry={setCountry}
                      workAddress={workAddress}
                      setWorkAddress={setWorkAddress}
                      workCity={workCity}
                      setWorkCity={setWorkCity}
                      workStateProvince={workStateProvince}
                      setWorkStateProvince={setWorkStateProvince}
                      workPostalZipCode={workPostalZipCode}
                      setWorkPostalZipCode={setWorkPostalZipCode}
                      workCountry={workCountry}
                      setWorkCountry={setWorkCountry}
                      memberId={memberId}
                    />
                  )}
                  {activeTab === "operations" && (
                    <OperationInfromation
                      listMemberData={props.listMemberData}
                      memberId={memberId}
                      getUserById={props?.getUserById}
                    />
                  )}
                  {activeTab === "uploads" && (
                    <Uploads
                      listMemberData={props.listMemberData}
                      memberId={memberId}
                      getUserById={props?.getUserById}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileInformation;
